export default {
  payWelfareText: 'Бонусы пополнения',
  blackFridayDiscount: 'Скидка Чёрной пятницы',
  shareGift: 'Дружеский подарок',
  vipWeeklyWelfare: 'Недельная скидка VIP',
  exchangeCoupon: 'Купон',
  firstPayOff: 'Скидка до 15% на первую покупку',
  blackFridayEvent: 'Событие Чёрной пятницы',
  limitedTimeOff: 'Особая 10% скидка',
  claimCoupon: 'Получить сейчас',
  blackFridayTimedCoupon: 'Купон Чёрной пятницы',
  timeLeft: 'Осталось:',
  claimTimeCoupon: 'Получите особую 10% скидку!',
  points: 'Пункты: ${point}',
  costPointTip: 'Обменивайте пункты на купоны',
  maxPointTip: 'На аккаунте можно использовать до 500 пунктов.',
  discountOff: 'СКИДКА 10%',
  highestDiscount: 'Скидка до ${discount} ',
  needPoint: 'Нужно ${point} пунктов',
  changeCurrency: 'Сменить валюту',
  claim: 'Получить',
  claimSucc: 'Получено',
  claimFail: 'Неудача',
  pointNotEnough: 'Недостаточно пунктов',
  afterClaimPoint: 'Осталось пунктов: ${point}',
  footTips1: 'На каждый заказ применяется только 1 купон.',
  footTips2: 'Купоны не применяются для покупки игровой валюты/жетонов.',
  footTips3:
    'Мы оставляем за собой право окончательной трактовки правил данного события.',
  ruleTitleText: 'Правила события',
  ruleTime:
    'Время события: с [00:00] 24 ноября 2023 до [23:59] 26 ноября 2023 (UTC)',
  bfRuleText1:
    '1. После первого посещения официальной страницы пополнения счета во время события вам будет начислено 400 пунктов. Можно будет обменять на купоны до 500 пунктов.',
  bfRuleText2:
    '2. Во время события вы можете обменять очки Чёрной пятницы на купоны.',
  bfRuleText3:
    '3. На каждый заказ применяется только 1 купон. Купоны не применяются для покупки игровой валюты/жетонов.',
  bfRuleText4: '4. Для транзакций доступны следующие валюты:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. После выполнения транзакции вы не сможете поменять валюту. Обмененные пункты не возмещаются.',
  bfRuleText6: '6. Купоны Чёрной пятницы действительны в течение 7 дней.',
  bfRuleText7:
    '7. Мы оставляем за собой право окончательной трактовки правил данного события.',
  thanksTip:
    'Спасибо за участие. Больше информации вы сможете получить, посетив наше официальное сообщество.',
  exchangePoints: 'Обмен',
  exchangeCode: 'Введите код обмена.',
  enterExchangeCode: 'Введите код обмена.',
  exchangeText: 'Обмен',
  confirmGet: 'Принять',
  couponUsedWay:
    'Купон можно обменять только с определёнными валютами, подтвердите валюту.',
  confirmText: 'Принять',
  exchangeSucc: 'Обменено',
  aboutCoins: 'Об игровой валюте/жетонах',
  aboutCoinsText:
    'Вы можете обменять игровую валюту/жетоны на любые наборы и привилегии, исключая игровую валюту/жетоны.',
  known: 'Принять',
  codeText: 'Код',
  codeInvalid: 'Неверный код!',
  hasExchanged: 'Больше нельзя получить коды.',
  hideText: 'Скрыть',
  //黑五的报错码
  'bf-20001': 'Вход не выполнен',
  'bf-20002': 'Ошибка параметра. Пожалуйста, попробуйте перезапустить событие.',
  'bf-20003': 'Недостаточно пунктов',
  'bf-20004': 'Неудача! Повторите попытку или напишите в службу поддержки.',
  'bf-20005': 'Получено',
  'bf-20015': 'Событие в данный момент недоступно.',
  'bf-20016': 'Событие завершилось.',
  bfShareText: 'Получите особую 10% скидку!',
  rightsCenterBtn: 'Центр Премиум участников',
  payBtn: 'ПОКУПКУ',
  hasEqualRewardMuglo: 'До 1800 БОНУСНЫХ алмазов за покупки на официальном сайте!',
  productInterceptPopupTitle: 'Покупка не выполнена',
  productInterceptPopupTip: 'Система недоступна в вашем регионе.<br>Если у вас остались вопросы, пожалуйста, обратитесь в службу поддержки.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Великий и необычный (Навсегда)',
  '-': '-'
};
